var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrameTera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 139,
    viewBox: "0 0 83 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4371_8181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.01 17.8661C155.084 34.3914 154.748 48.103 149.644 62.03C144.616 75.874 134.82 89.9335 123.734 89.5585C112.573 89.2666 100.205 74.6161 80.2599 70.2618C60.3906 65.8244 33.0271 71.7592 17.1578 62.4429C1.2885 53.1266 -3.08652 28.5592 3.39546 8.11983C9.96049 -12.2437 27.4584 -28.5623 46.1869 -40.5569C64.9083 -52.7104 84.9433 -60.464 104.275 -59.108C123.448 -57.7447 141.911 -47.4308 150.305 -32.6007C158.616 -17.8465 157.018 1.41662 156.01 17.8661Z",
    fill: "#314155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4371_8181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 223,
    height: 223,
    fill: "white",
    transform: "translate(0 -84)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameTera);
export default __webpack_public_path__ + "static/media/FrameTera.3c29fa62.svg";
export { ForwardRef as ReactComponent };